module.exports = __webpack_public_path__ + "media/images/homes/AddEmployeestoYourTeam-b6acd50d2cf5cf5e842f2e812386dde3.png";